<template>
    <element-badge :color="statusColor" uppercase>{{ budget.status }}</element-badge>
</template>

<script>
import BudgetProjection from '@/Models/BudgetProjection';

export default {
    props: {
        budget: {
            type: BudgetProjection,
            required: true,
        },
    },

    computed: {
        statusColor() {
            switch (this.budget.status) {
                case BudgetStatus.LOCKED:
                    return 'red';
                case BudgetStatus.IN_REVIEW:
                    return 'yellow';
                case BudgetStatus.DRAFT:
                default:
                    return 'green';
            }
        },
    },
};
</script>
